import { flow, pipe } from 'fp-ts/lib/function';
import { iso } from 'newtype-ts';
import * as Mmt from '../measurement';
import * as FD from './floordimensions';
import { Lens } from 'monocle-ts';
import { applyFurnitureRotation, instanceId } from '../furniture';
import { Orientation3D, Vector3D } from '@fixtuur/fine';
// provides ability to wrap, unwrap, and modify the newtype
const _ = iso();
// export functions from here
export const create = _.wrap;
export const createRectangleMeters = ({ height, width, depth, }) => pipe(FD.createRectangleMeters(width, depth), fd => _.wrap({
    height: Mmt.createMeters(height),
    floorDimensions: fd,
    furniture: [],
    selectedFurniture: null,
}));
export const updateSelectedFurniture = (id) => _.modify(r => ({ ...r, selectedFurniture: id === r.selectedFurniture ? null : id }));
export const selectedFurniture = flow(_.unwrap, r => r.selectedFurniture);
/** A set of functions to operate over the floorDimensions prop on the Room type, for convenience */
const floorDimensionsL = _.composeLens(Lens.fromProp()('floorDimensions'));
const heightL = _.composeLens(Lens.fromProp()('height'));
export const floorDimensions = floorDimensionsL.get;
export const updateRectangle = (width, depth) => floorDimensionsL.modify(FD.updateRectangle(width, depth));
export const widthMeters = flow(floorDimensions, FD.widthMeters);
export const depthMeters = flow(floorDimensions, FD.depthMeters);
export const floorVerticesMeters = flow(floorDimensions, FD.verticesMeters);
export const heightMeters = flow(heightL.get, Mmt.meters);
export const addFurniture = (furniture) => _.modify(r => ({ ...r, furniture: r.furniture.concat(furniture) }));
export const removeSelectedFurniture = (id) => _.modify(r => ({
    ...r,
    furniture: r.furniture.filter(f => instanceId(f) !== r.selectedFurniture),
    selectedFurniture: id === r.selectedFurniture ? null : id,
}));
export const rotateSelectedFurniture = (id, rotationAngle) => _.modify(r => ({
    ...r,
    furniture: r.furniture.map(f => {
        if (instanceId(f) === id && r.selectedFurniture === id) {
            applyFurnitureRotation(new Orientation3D(1, new Vector3D([0, rotationAngle, 0])));
            return f;
        }
        else {
            return f;
        }
    }),
}));
export const furniture = flow(_.unwrap, x => x.furniture);
